var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"width":"100%"}},[_c('v-card-title',[_vm._v("Prestaciones a pagar - "+_vm._s(_vm.plan.nombre))]),_c('v-divider',{staticClass:"mb-6"}),_c('v-card-text',[_c('pagar-component')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }